import { mutatorAction } from "satcheljs";
import { getStore } from "../store/store";

/**
 * Updates the heartbeat memory sizes (in MB).
 * Called by AppPerformanceMetricsService after each heartbeat tick.
 */
export const setHeartbeatMemorySizesMbMutator: (workingSetSizeMb: number | undefined, commitSizeMb: number | undefined, isProcessShared: boolean | undefined) => void = mutatorAction("setHeartbeatMemorySizesMbMutator", (workingSetSizeMb: number | undefined, commitSizeMb: number | undefined, isProcessShared: boolean | undefined): void => {
    const store = getStore();
    store.heartbeatWorkingSetSizeMb = workingSetSizeMb;
    store.heartbeatCommitSizeMb = commitSizeMb;
    store.isProcessShared = isProcessShared;
});
